/**
 * L'Invoice project translations
 * Isolated namespace for Invoice project translations
 * Structure is organized by feature area for scalability
 */

import sidebar from "./sidebar";
import reports from "./reports";
import pages from "./pages";
import buttons from "./buttons";
import labels from "./labels";
import emptyStates from "./emptyStates";
import statuses from "./statuses";
import validation from "./validation";
import tooltips from "./tooltips";
import modals from "./modals";
import sendResponse from "./sendResponse";

const einvoice = {
  sidebar,
  reports,
  pages,
  buttons,
  labels,
  emptyStates,
  statuses,
  validation,
  tooltips,
  modals,
  sendResponse,
};

export default einvoice;
